// product-custom-handlers.js
// Depends on: jQuery, allVariants (global, set inline before this script loads),
// and productHandlerConfig (global config object set inline with Liquid-rendered values).

function initHandlers() {
  const trigger = $('.product .product-form__custom-input .trigger-modal');
  const modal = $('.product-form__modal');
  const closeButton = $('.product-form__modal .product-addToCart__close');
  const modalBackdrop = $('.product-form__modal .product-form__modal-backdrop');
  const modalButton = $('.js-product-addToCart__btn button');
  const quantityInput = $('.product .product-form__custom-input .quantity__input');
  const quantityModalEl = $('.product-form__modal .product-addToCart__characteristics-quantity');

  $(modalButton).on('click', function () {
    $(trigger).find('.product-form__submit').click();

    setTimeout(() => {
      $(modalBackdrop).click();
      $(modal).find('input[type="checkbox"]').prop('checked', false);
    }, 500);
  });

  $(modalBackdrop).on('click', function () {
    $(modal).fadeOut();
    $('body').removeClass('prevent-overflow');
  });

  $(closeButton).on('click', function () {
    $(modal).fadeOut();
    $('body').removeClass('prevent-overflow');
  });

  $(trigger).on('click', function (event) {
    const quantity = $(quantityInput).val();
    $(quantityModalEl).html(quantity);

    event.stopImmediatePropagation();
    $(modal).fadeIn();
    $('body').addClass('prevent-overflow');
  });
}

document.addEventListener('productInfoUpdated', initHandlers);

$(document).ready(function () {
  initHandlers();
  removeUnavailableWord();
  lastChoices();
  checkAllVariants( productHandlerConfig.firstOption );
})
;



let selectOption__1 = $( `variant-selects .product-form__input.customElements[option="1"] .variantWrap` );
let selectOption__2 = $( `variant-selects .product-form__input.customElements[option="2"] .variantWrap` );
let selectOption__3 = $( `variant-selects .product-form__input.customElements[option="3"] .variantWrap` );
let mainSelectedArr, mainSelectedObject, secondOptionArr, lastChoice1, lastChoice2, lastChoice3;

$(document)
.on(`click`, `.dropdown`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const opNo = $( this ).closest( `.product-form__input` ).attr( `option` ) * 1;
    const availableOptions = $( `variant-selects .product-form__input.product-form__input--dropdown[option="${ opNo }"] .dropdown .dropdown-content span[is-available="true"]` ).length;
    if ( availableOptions == 0 ) {
      $( `variant-selects .product-form__input.product-form__input--dropdown[option="${ opNo }"] .dropdown .dropdown-content span` ).attr( `is-available`, true );
    }
    $( this ).addClass( `open` );
  } catch ( err ) {
    console.log( `ERROR .select2-container`, err.message );
  }
})
.on(`mouseleave`, `.dropdown`, function( e ) {
  try {
    e.stopImmediatePropagation();
    $( this ).removeClass( `open` );
  } catch ( err ) {
    console.log( `ERROR .select2-container`, err.message );
  }
})

.on(`click`, `.dropdown .dropdown-content span:not(.selected)`,async function( e ) {
  try {
    e.stopImmediatePropagation();
    $( this ).closest( `variant-selects` ).attr( `is-loading`, true );

    await chooseOption( this );

    await addDelay( 1000 );
    await showHideOptions();
    await addDelay( 200 );
    await fillEmpty();
    // await checkAllVariants();
    $( this ).closest( `variant-selects` ).attr( `is-loading`, false );
  } catch ( err ) {
    console.log( `ERROR .dropdown .dropdown-content span`, err.message );
  }
})
.on(`click`, `.dropdown .dropdown-content span.selected`,async function( e ) {
  try {
    e.stopImmediatePropagation();
    $( this ).closest( `.dropdown` ).removeClass( `open` );
  } catch ( err ) {
    console.log( `ERROR .dropdown .dropdown-content span.selected`, err.message );
  }
})
.on('input', 'input.quantity__input', function () {
  let $input = $(this);
  let val = $input.val();

  val = val.replace(/[^\d]/g, '');
  $input.val(val);
})
.on('blur', 'input.quantity__input', function () {
  let $input = $(this);
  let val = parseInt($input.val(), 10);
  let min = parseInt($input.attr('min'), 10) || 1;

  if (isNaN(val) || val < min) {
    $input.val(min);
  }
})


const productVID_Is = document.querySelector('.product-form__custom-input .form[data-type="add-to-cart-form"] .product-variant-id');

if ( productVID_Is ) {
  const observer = new MutationObserver(() => {
    const selectedObject__ = findObjectByKey( allVariants, `id`, productVID_Is.value );
    console.log ( 'selectedObject__', selectedObject__ );
    if ( typeof selectedObject__ !== 'undefined' && selectedObject__ && typeof selectedObject__.min_qty !== 'undefined' && selectedObject__.min_qty ) {
      $( `quantity-input input.quantity__input` ).attr({
        "min": selectedObject__.min_qty,
        "data-min": selectedObject__.min_qty,
        "value": selectedObject__.min_qty
      });
    }
    // quantity-input input.quantity__input
    // console.log('Input value changed to:', productVID_Is.value);
  });

  observer.observe(productVID_Is, {
    attributes: true,
    attributeFilter: ['value']
  });
}


async function chooseOption( this_ ) {
  try {
    const getOptionNo = $( this_ ).closest( `.product-form__input[option]` ).attr( `option` ) * 1;
    // console.log ( 'getOptionNo', getOptionNo );
    const opText = $( this_ ).text().trim();
    const getVal = $( this_ ).attr( `val` );
    if ( typeof getVal !== 'undefined' && getVal ) {
      // console.log ( 'getVal', getVal );
      $( this_ ).closest( `.dropdown` ).find( `.dropdown-content span` ).removeClass( `selected` );
      $( this_ ).addClass( `selected` );
      $( this_ ).closest( `.dropdown` ).removeClass( `open` ).find( `.dropbtn span` ).text( opText );

      if ( getOptionNo == 1 ) {
        const selectedVariantsArr = findObjectByKey( allVariants, `option1__converted`, getVal, true );
        if ( typeof selectedVariantsArr !== 'undefined' && selectedVariantsArr ) {
          const getObjectData = makeSelectedVariantObj( selectedVariantsArr );
          if ( typeof getObjectData !== 'undefined' && getObjectData ) {
            mainSelectedObject = getObjectData;
          }
        }

        await changeVariantOption( 1 );

        document.querySelector( `variant-selects .product-form__input.customElements[option="1"] .variantWrap label[val="${ getVal }"]` ).click();
      } else if ( getOptionNo == 2 ) {
        await changeVariantOption( 2, getVal );
        document.querySelector( `variant-selects .product-form__input.customElements[option="2"] .variantWrap label[val="${ getVal }"]` ).click();
      } else if ( getOptionNo == 3 ) {
        document.querySelector( `variant-selects .product-form__input.customElements[option="3"] .variantWrap label[val="${ getVal }"]` ).click();
      }
    }
  } catch ( err ) {
    console.log( `ERROR chooseOption`, err.message );
  }
}

async function showHideOptions() {
  try {
    const op1 = $( `variant-selects .product-form__input[option="1"] .dropdown .dropdown-content span.selected` ).attr( `val` );
    const op2 = $( `variant-selects .product-form__input[option="2"] .dropdown .dropdown-content span.selected` ).attr( `val` );
    const op3 = $( `variant-selects .product-form__input[option="3"] .dropdown .dropdown-content span.selected` ).attr( `val` );

    if ( typeof mainSelectedObject !== 'undefined' && mainSelectedObject && typeof mainSelectedObject.op2 !== 'undefined' && mainSelectedObject.op2 && mainSelectedObject.op2.length > 0 && typeof op2 !== 'undefined' && op2 ) {
      if ( $( `variant-selects .product-form__input[option="2"]` ).length > 0 ) {
        let collectThirdOption = null;
        $( `variant-selects .product-form__input[option="2"] .dropdown .dropdown-content span` ).attr( `is-available`, false );
        mainSelectedObject.op2.forEach(obj => {
          if ( op2 == obj.opName && typeof obj.option3__converted !== 'undefined' && obj.option3__converted && obj.option3__converted.length > 0 ) {
            collectThirdOption = obj.option3__converted;
          }
          $( `variant-selects .product-form__input[option="2"] .dropdown .dropdown-content span[val="${ obj.opName }"]` ).attr( `is-available`, true );
        });

        if ( $( `variant-selects .product-form__input[option="3"]` ).length > 0 && typeof collectThirdOption !== 'undefined' && collectThirdOption && collectThirdOption.length > 0 ) {
          console.log ( 'collectThirdOption', collectThirdOption );
          $( `variant-selects .product-form__input[option="3"] .dropdown .dropdown-content span` ).attr( `is-available`, false );
          collectThirdOption.forEach(e => {
            $( `variant-selects .product-form__input[option="3"] .dropdown .dropdown-content span[val="${ e }"]` ).attr( `is-available`, true );
          });
        }
      }
    }
    if ( typeof op1 !== 'undefined' && op1 ) {
      console.log ( 'op1', op1 );
    }
    if ( typeof op2 !== 'undefined' && op2 ) {
      console.log ( 'op2', op2 );
    }
    if ( typeof op3 !== 'undefined' && op3 ) {
      console.log ( 'op3', op3 );
    }
  } catch ( err ) {
    console.log( `ERROR showHideOptions()`, err.message );
  }
}
async function fillEmpty() {
  try {
    const op1 = $( `variant-selects .product-form__input[option="1"] .dropdown .dropdown-content span.selected` ).attr( `val` );
    const op2 = $( `variant-selects .product-form__input[option="2"] .dropdown .dropdown-content span.selected` ).attr( `val` );
    const op3 = $( `variant-selects .product-form__input[option="3"] .dropdown .dropdown-content span.selected` ).attr( `val` );

    if ( typeof op1 !== 'undefined' && op1 ) {
      console.log ( 'fillEmpty op1', op1 );
    }
    if ( typeof op2 !== 'undefined' && op2 ) {
      console.log ( 'fillEmpty op2', op2 );
    }
    if ( typeof op3 !== 'undefined' && op3 ) {
      console.log ( 'fillEmpty op3', op3 );
    }
    isStockAvailable();
  } catch ( err ) {
    console.log( `ERROR showHideOptions()`, err.message );
  }
}

async function changeVariantOption( optionNo, currentValue=null ) {
  const selectOption__1_ = $( `variant-selects .product-form__input.customElements[option="1"] .variantWrap` );
  const selectOption__2_ = $( `variant-selects .product-form__input.customElements[option="2"] .variantWrap` );
  const selectOption__3_ = $( `variant-selects .product-form__input.customElements[option="3"] .variantWrap` );
  if ( optionNo == 1 ) {
    if ( typeof selectOption__2_ !== 'undefined' && selectOption__2_ ) {
      const getOp2__val = $( `variant-selects .product-form__input.customElements[option="2"] .variantWrap input[type="radio"]:checked` ).attr( `val` );
      let isSecondOptionMatched = false;
      let thirdOptionArr;
      if ( typeof mainSelectedObject !== 'undefined' && mainSelectedObject && typeof mainSelectedObject.op2 !== 'undefined' && mainSelectedObject.op2 && mainSelectedObject.op2.length > 0 ) {
        console.log ( 'you are in', getOp2__val );
        mainSelectedObject.op2.forEach(obj => {
          if ( obj.opName == getOp2__val ) {
            isSecondOptionMatched = true;
            if ( typeof obj.option3__converted && obj.option3__converted && obj.option3__converted.length > 0 ) {
              thirdOptionArr = obj.option3__converted;
            }
          }
        });

        console.log ( 'isSecondOptionMatched', isSecondOptionMatched );

        if ( isSecondOptionMatched == false ) {
          console.log ( 'mainSelectedObject.op2[0].opName', mainSelectedObject.op2[0].opName );
          $( `variant-selects .product-form__input.customElements[option="2"] .variantWrap input[type="radio"][val="${ mainSelectedObject.op2[0].opName }"]` ).prop( `checked`, true );
          mainSelectedObject.op2.forEach(obj => {
          if ( obj.opName == mainSelectedObject.op2[0].opName ) {
            isSecondOptionMatched = true;
            if ( typeof obj.option3__converted && obj.option3__converted && obj.option3__converted.length > 0 ) {
              thirdOptionArr = obj.option3__converted;
            }
          }
        });
        }
      }

      if ( typeof selectOption__3_ !== 'undefined' && selectOption__3_ ) {
        const getOp3__val = $( `variant-selects .product-form__input.customElements[option="3"] .variantWrap input[type="radio"]:checked` ).attr( `val` );
        console.log ( 'getOp3__val', getOp3__val );
        let isThirdOptionMatched = false;
        console.log ( 'thirdOptionArr before', thirdOptionArr );
        if ( typeof thirdOptionArr !== 'undefined' && thirdOptionArr && thirdOptionArr.length > 0 ) {
          console.log ( 'thirdOptionArr', thirdOptionArr );
          thirdOptionArr.forEach(obj => {
            if ( obj == getOp3__val ) {
              isThirdOptionMatched = true;
            }
          });

          console.log ( 'isThirdOptionMatched', isThirdOptionMatched );
          console.log ( 'thirdOptionArr[0]', thirdOptionArr[0] );
          console.log ( 'thirdOptionArr', thirdOptionArr );

          if ( isThirdOptionMatched == false ) {
            $( `variant-selects .product-form__input.customElements[option="3"] .variantWrap input[type="radio"][val="${ thirdOptionArr[0] }"]` ).prop( `checked`, true );
          }
        }
      }
    }
  } else if ( optionNo == 2 && currentValue != null ) {
    if ( typeof selectOption__2_ !== 'undefined' && selectOption__2_ ) {
      const getOp2__val = currentValue;
      console.log ( 'getOp2__val', getOp2__val );
      let thirdOptionArr;
      if ( typeof mainSelectedObject !== 'undefined' && mainSelectedObject && typeof mainSelectedObject.op2 !== 'undefined' && mainSelectedObject.op2 && mainSelectedObject.op2.length > 0 ) {
        mainSelectedObject.op2.forEach(obj => {
          if ( obj.opName == getOp2__val ) {
            if ( typeof obj.option3__converted && obj.option3__converted && obj.option3__converted.length > 0 ) {
              thirdOptionArr = obj.option3__converted;
              console.log ( 'thirdOptionArr', thirdOptionArr );
            }
          }
        });
      }

      if ( typeof selectOption__3_ !== 'undefined' && selectOption__3_ ) {
        const getOp3__val = $( `variant-selects .product-form__input.customElements[option="3"] .variantWrap input[type="radio"]:checked` ).attr( `val` );
        console.log ( 'getOp3__val', getOp3__val );
        let isThirdOptionMatched = false;
        if ( typeof thirdOptionArr !== 'undefined' && thirdOptionArr && thirdOptionArr.length > 0 ) {
          thirdOptionArr.forEach(obj => {
            if ( obj == getOp3__val ) {
              isThirdOptionMatched = true;
            }
          });

          if ( isThirdOptionMatched == false ) {
            $( `variant-selects .product-form__input.customElements[option="3"] .variantWrap input[type="radio"][val="${ thirdOptionArr[0] }"]` ).prop( `checked`, true );
          }
        }
      }
    }
  }
  await addDelay( 500 );
}



async function checkAllVariants( firstOption = null ) {
  try {
    if ( firstOption != null ) {
      const selectedVariantsArr = findObjectByKey( allVariants, `option1__converted`, firstOption, true );
      if ( typeof selectedVariantsArr !== 'undefined' && selectedVariantsArr ) {
        const getObjectData = makeSelectedVariantObj( selectedVariantsArr );
        if ( typeof getObjectData !== 'undefined' && getObjectData ) {
          mainSelectedObject = getObjectData;
        }
      }
    }
    await setOptionNames();
    await recheckOptions();
  } catch ( err ) {
    console.log( `ERROR checkAllVariants()`, err.message );
  }
}

function makeSelectedVariantObj( arr ) {
  try {
    let rtn;
    if ( arr.length > 0 ) {
      let newObj = {
        "op1": arr[0].option1__converted
      };
      const makeGroups = groupByOptions( arr );
      if ( typeof makeGroups !== 'undefined' && makeGroups ) {
        newObj.op2 = makeGroups;
      }
      // console.log ( 'newObj', newObj );
      return newObj;
    }
    return null;
  } catch ( err ) {
    console.log( `ERROR `, err.message );
  }
}

async function lastChoices() {
  try {
    // let getOp1 = $( `variant-selects .product-form__input.product-form__input--dropdown[option="1"] .dropdown .dropdown-content` );
    // let getOp2 = $( `variant-selects .product-form__input.product-form__input--dropdown[option="2"] .dropdown .dropdown-content` );
    // let getOp3 = $( `variant-selects .product-form__input.product-form__input--dropdown[option="3"] .dropdown .dropdown-content` );

    // if ( typeof getOp1 !== 'undefined' && getOp1 ) {
    //   lastChoice1 = getOp1.find( `.selected` ).attr( `val` );
    //   console.log ( 'lastChoice1', lastChoice1 );
    // }
    // if ( typeof getOp2 !== 'undefined' && getOp2 ) {
    //   lastChoice2 = getOp2.find( `.selected` ).attr( `val` );
    //   console.log ( 'lastChoice2', lastChoice2 );
    // }
    // if ( typeof getOp3 !== 'undefined' && getOp3 ) {
    //   lastChoice3 = getOp3.find( `.selected` ).attr( `val` );
    //   console.log ( 'lastChoice3', lastChoice3 );
    // }
  } catch ( err ) {
    console.log( `ERROR lastChoices()`, err.message );
  }
}



async function setOptionNames() {
  try {
    const firstSelectedOption = $( `variant-selects .product-form__input.product-form__input--dropdown[option="1"] .dropdown .dropdown-content span.selected` ).attr( `val` );
    const secondSelectedOption = $( `variant-selects .product-form__input.product-form__input--dropdown[option="2"] .dropdown .dropdown-content span.selected` ).attr( `val` );
    let selectedArr;
    if ( typeof firstSelectedOption !== 'undefined' && firstSelectedOption ) {
      selectedArr = findObjectByKey( allVariants, `option1__converted`, firstSelectedOption, true );

      console.log ( 'selectedArr', selectedArr );
    }
    if ( $( `variant-selects .product-form__input.product-form__input--dropdown[option="1"]` ).length > 0 ) {
      $( `variant-selects .product-form__input.product-form__input--dropdown[option="1"] .dropdown .dropbtn span` ).empty();
      let selected_op1 = $( `variant-selects .product-form__input.product-form__input--dropdown[option="1"] .dropdown .dropdown-content span.selected` ).attr( `val` );

      if ( typeof selected_op1 !== 'undefined' && selected_op1 ) {
        // console.log ( 'con 1',  );
        $( `variant-selects .product-form__input.product-form__input--dropdown[option="1"] .dropdown .dropbtn span` ).text( selected_op1 );
      } else {
        await addDelay( 250 );
        selected_op1 = $( `variant-selects .product-form__input.product-form__input--dropdown[option="1"] .dropdown .dropdown-content span.selected` ).attr( `val` );
        if ( typeof selected_op1 !== 'undefined' && selected_op1 ) {
          $( `variant-selects .product-form__input.product-form__input--dropdown[option="1"] .dropdown .dropbtn span` ).text( selected_op1 );
        }
      }

      if ( typeof selectedArr !== 'undefined' && selectedArr && selectedArr.length > 0 ) {
        $( `variant-selects .product-form__input[option="2"] .dropdown-content span` ).attr( `is-available`, false );
        selectedArr.forEach(o => {
          $( `variant-selects .product-form__input[option="2"] .dropdown-content span[val="${ o.option2__converted }"]` ).attr( `is-available`, true );
        });
        const is2ndOptionSelected = $( `variant-selects .product-form__input[option="2"] .dropdown-content span[is-available="true"]` ).hasClass( `selected` );
        // console.log ( 'con 3',  );
        if ( is2ndOptionSelected == false ) {
          $( `variant-selects .product-form__input[option="2"] .dropdown-content span[is-available="true"]` ).first().click();
        }
      }
    }

    if ( $( `variant-selects .product-form__input.product-form__input--dropdown[option="2"]` ).length > 0 ) {
      // console.log ( 'con 4',  );
      $( `variant-selects .product-form__input.product-form__input--dropdown[option="2"] .dropdown .dropbtn span` ).empty();
      const selected_op2 = $( `variant-selects .product-form__input.product-form__input--dropdown[option="2"] .dropdown .dropdown-content span.selected` ).attr( `val` );
      if ( typeof selected_op2 !== 'undefined' && selected_op2 ) {
        // console.log ( 'con 5',  );
        $( `variant-selects .product-form__input.product-form__input--dropdown[option="2"] .dropdown .dropbtn span` ).text( selected_op2 );
      } else {
        // console.log ( 'con 6',  );
        $( `variant-selects .product-form__input.product-form__input--dropdown[option="2"] .dropdown .dropbtn span` ).text( selected_op2 );
      }


      if ( typeof selectedArr !== 'undefined' && selectedArr ) {
        // console.log ( 'con 7',  );
        const secondSelectedArr = findObjectByKey( selectedArr, `option2__converted`, selected_op2, true );
        if ( typeof secondSelectedArr !== 'undefined' && secondSelectedArr && secondSelectedArr.length > 0 ) {
          // console.log ( 'con 8',  );
          $( `variant-selects .product-form__input[option="3"] .dropdown-content span` ).attr( `is-available`, false );
          secondSelectedArr.forEach(o => {
            $( `variant-selects .product-form__input[option="3"] .dropdown-content span[val="${ o.option3__converted }"]` ).attr( `is-available`, true );
          });
          const is3rdOptionSelected = $( `variant-selects .product-form__input[option="3"] .dropdown-content span[is-available="true"]` ).hasClass( `selected` );
          if ( is3rdOptionSelected == false ) {
            // console.log ( 'con 9',  );
            $( `variant-selects .product-form__input[option="3"] .dropdown-content span[is-available="true"]` ).first().click();
          }
        }
      }
    }

    if ( $( `variant-selects .product-form__input.product-form__input--dropdown[option="3"]` ).length > 0 ) {
      // console.log ( 'con 10',  );
      $( `variant-selects .product-form__input.product-form__input--dropdown[option="3"] .dropdown .dropbtn span` ).empty();
      const selected_op3 = $( `variant-selects .product-form__input.product-form__input--dropdown[option="3"] .dropdown .dropdown-content span.selected` ).attr( `val` );
      if ( typeof selected_op3 !== 'undefined' && selected_op3 ) {
        // console.log ( 'con 11',  );
        $( `variant-selects .product-form__input.product-form__input--dropdown[option="3"] .dropdown .dropbtn span` ).text( selected_op3 );
      } else {
        // console.log ( 'con 12',  );
        $( `variant-selects .product-form__input.product-form__input--dropdown[option="3"] .dropdown .dropbtn span` ).text( selected_op3 );
      }
    }
    await addDelay( 1000 );
    $( `variant-selects` ).attr( `is-loading`, false );
  } catch ( err ) {
    console.log( `ERROR setOptionNames()`, err.message );
  }
}

async function recheckOptions() {
  try {
  } catch ( err ) {
    console.log( `ERROR recheckOptions()`, err.message );
  }
}

function replaceWords_( variable_, rFrom, rTo ) {
  let rtn;
  if ( typeof variable_ !== 'undefined' && variable_ && typeof rFrom !== 'undefined' && rFrom && typeof rTo !== 'undefined' && rTo ) {
    for (let i = 0; i < 5; i++) {
      if ( variable_.includes( rFrom ) ) {
        variable_ = variable_.replace( rFrom, rTo );
      } else {
        break;
      }
    }
  } else {
    return null;
  }

  if ( variable_ != '' ) {
    return variable_;
  }

}
function removeUnavailableWord() {
  try {
    let getOp1 = $( `variant-selects .product-form__input[option="1"] .select2.select2-container .select2-selection__rendered` ).text();
    let getOp2 = $( `variant-selects .product-form__input[option="2"] .select2.select2-container .select2-selection__rendered` ).text();
    let getOp3 = $( `variant-selects .product-form__input[option="3"] .select2.select2-container .select2-selection__rendered` ).text();
    if ( typeof getOp1 !== 'undefined' && getOp1.includes( ` - Unavailable` ) ) {
      getOp1 = getOp1.replace( ` - Unavailable`, `` ).trim();
      $( `variant-selects .product-form__input[option="1"] .select2.select2-container .select2-selection__rendered` ).text( getOp1 );
    }
    if ( typeof getOp2 !== 'undefined' && getOp2.includes( ` - Unavailable` ) ) {
      getOp2 = getOp2.replace( ` - Unavailable`, `` ).trim();
      $( `variant-selects .product-form__input[option="2"] .select2.select2-container .select2-selection__rendered` ).text( getOp2 );
    }
    if ( typeof getOp3 !== 'undefined' && getOp3.includes( ` - Unavailable` ) ) {
      getOp3 = getOp3.replace( ` - Unavailable`, `` ).trim();
      $( `variant-selects .product-form__input[option="3"] .select2.select2-container .select2-selection__rendered` ).text( getOp3 );
    }
  } catch ( err ) {
    console.log( `ERROR removeUnavailableWord()`, err.message );
  }
}
$(document).ready(function () {
  setMediaGallerySliderHeight();
  const sliderImagesCount = $( `slider-component.thumbnail-slider .thumbnail-list .thumbnail-list__item` ).length;
  if ( sliderImagesCount > 1 ) {
    $( `slider-component.thumbnail-slider button.slider-button` ).removeAttr( `disabled` );
  }
})
.on(`click`, `slider-component.thumbnail-slider .slider-button.slider-button--prev`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const selectedSlide = $( `slider-component.thumbnail-slider .thumbnail-list .thumbnail-list__item button.thumbnail[aria-current="true"]` ).closest( `.thumbnail-list__item` ).attr( `data-media-position` ) * 1;
    const sliderImagesCount = $( `slider-component.thumbnail-slider .thumbnail-list .thumbnail-list__item` ).length;
    if ( selectedSlide == 1 ) {
      $( `slider-component.thumbnail-slider .thumbnail-list .thumbnail-list__item[data-media-position="${ sliderImagesCount }"] button.thumbnail` ).click();
      focusDiv( sliderImagesCount );
    } else {
      $( `slider-component.thumbnail-slider .thumbnail-list .thumbnail-list__item[data-media-position="${ selectedSlide - 1 }"] button.thumbnail` ).click();
      focusDiv( selectedSlide - 1 );
    }
  } catch ( err ) {
    console.log( `ERROR slider-component.thumbnail-slider button.slider-button.slider-button--prev`, err.message );
  }
})
.on(`click`, `slider-component.thumbnail-slider .slider-button.slider-button--next`, function( e ) {
  try {
    e.stopImmediatePropagation();
    const selectedSlide = $( `slider-component.thumbnail-slider .thumbnail-list .thumbnail-list__item button.thumbnail[aria-current="true"]` ).closest( `.thumbnail-list__item` ).attr( `data-media-position` ) * 1;
    const sliderImagesCount = $( `slider-component.thumbnail-slider .thumbnail-list .thumbnail-list__item` ).length;
    if ( selectedSlide == sliderImagesCount ) {
      $( `slider-component.thumbnail-slider .thumbnail-list .thumbnail-list__item[data-media-position="1"] button.thumbnail` ).click();
      focusDiv( 1 );
    } else {
      $( `slider-component.thumbnail-slider .thumbnail-list .thumbnail-list__item[data-media-position="${ selectedSlide + 1 }"] button.thumbnail` ).click();
      focusDiv( selectedSlide + 1 );
    }
  } catch ( err ) {
    console.log( `ERROR slider-component.thumbnail-slider button.slider-button.slider-button--next`, err.message );
  }
})
;
$(window).resize(function () {
  setMediaGallerySliderHeight()
});
async function focusDiv(index) {
  // console.log ( 'index', index );
  $( `.thumbnail-list .thumbnail-list__item[data-media-position="${ index }"] button` ).focus();
  // const focusableDivs = document.querySelectorAll('.thumbnail-list__item');
  // if (index >= 0 && index < focusableDivs.length) {
  //   focusableDivs[index].focus();
  //   focusableDivs[index].scrollIntoView({ behavior: 'smooth', block: 'end' });
  // }
}

function setMediaGallerySliderHeight() {
  try {
    const largeImgHeight = $( `slider-component.slider-mobile-gutter:not(.thumbnail-slider) ul.product__media-list` ).height();
    const thumbnailCount= $( `slider-component.slider-mobile-gutter:not(.thumbnail-slider) ul.product__media-list li` ).length;
    if ( typeof largeImgHeight !== 'undefined' && largeImgHeight ) {
      $( `slider-component.thumbnail-slider .thumbnail-list` ).css({"max-height": `${ largeImgHeight - 88 }px`,"overflow-x": "hidden", "overflow-y": "auto"});
    }
    if ( thumbnailCount > 7 ) {
      $( `top-gradient, bottom-gradient` ).removeClass( `hidden` );
    }
  } catch ( err ) {
    console.log( `ERROR setMediaGallerySliderHeight()`, err.message );
  }
}
